import dayjs from "dayjs";

const formatUSD = (liq: number) => usdFormatter.format(liq); /* $2,500.00 */

/**
 * Receive timestamp in string and return a formatted date
 * @param timestamp
 */
const formatTimestamp = (timestamp: number) =>
  dayjs(timestamp * 1000).format("DD.MM.YY HH:mm:ss");

/**
 * $ formatter
 */
const usdFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export { 
    formatUSD,
    formatTimestamp
}
